import {
  Button,
  ButtonsWrapper,
  Form,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  TextInput,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { FormListContentWrapper, FormItemWrapper, FormWrapper } from './interview-type-form.styles';

const InterviewTypeForm = ({
  onClose,
  onFinish,
  initialValues,
}: {
  onClose: () => void;
  onFinish: (values: any) => void;
  initialValues?: any;
}) => {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <FormWrapper isEdit={!!initialValues}>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues || { fieldsHeadlines: [''] }}
      >
        <Form.Item
          name="name"
          label={t('settings:employeeDevelopment.labels.interviewTypeName')}
          rules={[
            {
              required: true,
              message: t('settings:employeeDevelopment.validation.interviewTypeNameRequired'),
            },
          ]}
        >
          <TextInput
            maxLength={50}
            placeholder={t('settings:employeeDevelopment.labels.targetInterview')}
          />
        </Form.Item>
        <Form.List name="fieldsHeadlines">
          {(fields, { add, remove }) => (
            <FormListContentWrapper isEdit={!!initialValues}>
              <div>
                {fields.map(field => (
                  <FormItemWrapper
                    key={field.key}
                    isLast={fields.length > 1}
                    isBtn={fields.length - 1 === field.name}
                  >
                    <div>
                      <Form.Item
                        key={field.key}
                        name={[field.name]}
                        label={`${t('settings:employeeDevelopment.labels.headline')} ${
                          field.name + 1
                        }`}
                        rules={[
                          {
                            required: true,
                            message: t('common:validation.error.fieldRequired'),
                          },
                        ]}
                      >
                        <TextInput
                          maxLength={50}
                          placeholder={t('settings:employeeDevelopment.labels.getNewCustomers')}
                        />
                      </Form.Item>
                      {fields.length - 1 === field.name && (
                        <Button
                          type="text"
                          icon={ICONS.plus}
                          iconColor={PLATFORM_THEME_COLORS.primary.blue}
                          onClick={() => add()}
                        >
                          {t('settings:employeeDevelopment.buttons.addTextfield')}
                        </Button>
                      )}
                    </div>
                    {fields.length > 1 && (
                      <Icon
                        icon={ICONS.trash}
                        color={PLATFORM_THEME_COLORS.tone.red}
                        rightMargin={false}
                        size={22}
                        onClick={() => remove(field.name)}
                      />
                    )}
                  </FormItemWrapper>
                ))}
              </div>
            </FormListContentWrapper>
          )}
        </Form.List>
        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </FormWrapper>
  );
};

export default InterviewTypeForm;
